// For Add/Update Announcements and Notifications
import React, { useState, useMemo, useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import "react-calendar/dist/Calendar.css";

import Icon from "../../components/Icon";
import { StyledText } from "../../components";
import Modal from "../../components/Modal";
import {
  clearAddScheme,
  getNewSchemesById,
  addUpdateNewScheme,
  sendTestNotification,
  getAllDeepLinks,
} from "../../actions/scheme-action-types";
import {
  getAllStates,
  getAllDealers,
  getAllDistricts,
} from "../../actions/dealer-action-types";
import { getAllModel } from "../../actions/user-action-types";
import { CONTENT_TYPES, IMAGE_MIME } from "../../constant";

import ConfigData from "../../config/ca-config-json.json";

// New Imports
import styled from "styled-components";
import { FormikProvider, useFormik, Form } from "formik";
import { Typography, Grid } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import * as Yup from "yup";
import ContainerBox from "../../components/ContainerBox";
import DocumentPreview from "./components/DocumentPreview";
import Switch from "@mui/material/Switch";
import DatePicker from "../../components/DatePicker";
import { get, isEmpty } from "lodash";
import MarkdownEditor from "@uiw/react-markdown-editor";

import TestNotification from "./components/TestNotification";
import FormTextField from "../../components/FormTextField";
import FormSelectInput from "../../components/FormSelectInput";
import { Circle } from "../../components/Overlay";
import { toast } from "react-toastify";
import { uploadFileToBlob } from "../../utilities/utilsFunction";
import Button from "../../components/Button";
import useGetAllApps from "../../hooks/useGetAllApps";

const {
  languageOptions,
  documentTypes,
  distributionTypes,
  notificationScheduleType,
  repeatCycle,
  notificationEndType,
} = ConfigData;

////********Styled Components ********************/
const MainContainer = styled.div`
  padding: 20px 40px;
  overflow: hidden;
  input[type="file"] {
    color: transparent !important;
    width: 100px;
  }
`;

const BackContainer = styled.div`
  //background: #003e85;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 20px;
  left: 0px;
`;

const LoaderContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  background-color: rgb(0, 0, 0, 0.3);
  align-items: center;
  z-index: 999;
`;

const UploadPromotion = ({
  userData,
  allStates,
  allDealers,
  getAllDealers,
  getAllStates,
  clearAddScheme,
  visible,
  isEditMode,
  allModels,
  getAllModel,
  getAllDistricts,
  allDistricts,
  getSchemesById,
  schemeById,
  addUpdateScheme,
  sendTestNotification,
  getAllDeepLinks,
  allDeepLinks,
  ...props
}) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);
  const [announcementImage, setAnnouncementImage] = useState(null);
  const [notificationImage, setNotificationImage] = useState(null);
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment().add("days", 30));
  const [startJoinDate, setStartJoinDate] = useState(moment().subtract("years", 1));
  const [endJoinDate, setEndJoinDate] = useState(moment());
  const [notifyDate, setNotifyDate] = useState(moment());
  const [notifyTime, setNotifyTime] = useState("");
  const [notifyEndDate, setNotifyEndDate] = useState(moment().add("days", 30));
  const [testNotificationResponse, setTestNotificationResponse] = useState({});

  const [showTestNotifyModal, setShowTestNotifyModal] = useState(false);

  const { tenantList, appList, appInfo } = useGetAllApps();

  const schemeId = props.match.params.schemeId;

  const OTHER_DEEP_LINK = "other";

  useEffect(() => {
    getAllStates();
    getAllDistricts();
    getAllDealers();
    getAllModel();

    if (isEditMode) {
      getSchemesById(schemeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let history = useHistory();

  // Currently Not in use as Model selection dropDown is hide
  // eslint-disable-next-line no-unused-vars
  const modelsList = useMemo(() => {
    return allModels
      ?.sort(function (a, b) {
        return a.mODEL_NAME.localeCompare(b.mODEL_NAME, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      })
      .map(({ mODEL_NAME }) => ({
        value: mODEL_NAME,
        label: mODEL_NAME,
      }));
  }, [allModels]);

  const states = useMemo(() => {
    return allStates?.reduce?.((arr, { State_Id, State_Name }) => {
      if (State_Id !== 0) {
        arr.push({
          value: State_Id,
          label: State_Name,
        });
      }
      return arr;
    }, []);
  }, [allStates]);

  const districtsList = useMemo(() => {
    return (
      allDistricts?.map?.((val) => {
        return {
          value: val.District_Id,
          label: val.District_Name,
          ...val,
        };
      }, []) ?? []
    );
  }, [allDistricts]);

  const allDealersList = useMemo(() => {
    try {
      const dealers = allDealers?.reduce?.((arr, dealer) => {
        if (dealer?.erpcbucode) {
          arr.push({
            ...dealer,
            value: dealer?.dealerCode,
            label: dealer?.dealerName,
          });
        }
        return arr;
      }, []);
      return dealers;
    } catch {
      return [];
    }
  }, [allDealers]);

  const dealersERPList = useMemo(() => {
    const erpCodes = allDealersList?.reduce?.((arr, dealer) => {
      const i = arr.findIndex((val) => val.value === dealer?.erpcbucode);
      if (i < 0 && dealer?.erpcbucode) {
        arr.push({
          value: dealer?.erpcbucode,
          label: dealer?.erpcbucode,
        });
      }
      return arr;
    }, []);
    return erpCodes ?? [];
  }, [allDealersList]);

  // Handle Document Form Submit
  const handleSubmit = async (values) => {
    try {
      const notificationDateTimeStr = `${moment(values.notifyDate).format("DD-MM-YYYY")} ${values.notifyTime}`;
      const notificationDateTime = moment(
        notificationDateTimeStr,
        "DD-MM-YYYY HH:mm"
      );
      let notificationImageUrl = formik.values.notificationImageUrl ?? "";
      if (
        allowNotificationOrAlert &&
        formik.values.attachImgOnNotification &&
        notificationImage
      ) {
        setImageUploading(true);
        notificationImageUrl = await uploadFileToBlob(notificationImage);
        if (notificationImageUrl) {
          formik.setFieldValue("notificationImageUrl", notificationImageUrl);
          setNotificationImage(null);
        } else {
          toast.error("Something went wrong, Please try again later.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setImageUploading(false);
          return;
        }
      }
      let announcementDocUrl = formik.values.docUrl ?? "";
      if (
        isAnnouncement &&
        formik.values.documentType === documentTypes.image.value &&
        announcementImage
      ) {
        setImageUploading(true);
        announcementDocUrl = await uploadFileToBlob(announcementImage);
        if (announcementDocUrl) {
          formik.setFieldValue("docUrl", announcementDocUrl);
          setAnnouncementImage(null);
        } else {
          toast.error("Something went wrong, Please try again later.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setImageUploading(false);
          return;
        }
      }
      const requestPayload = {
        schemeHdrId: isEditMode ? schemeId : undefined, /// for update
        appId: appInfo(values.app).mainId,
        tenant: values.tenant,
        documentName: values.documentName,
        documentDesc: values.description,
        language: values.language,
        schemeVsDocTypeMappingList:
          values.contentType.map((item) => {
            return {
              docType: item,
            };
          }) ?? [],
        notificationTitle: allowNotificationOrAlert
          ? values.notificationTitle
          : "",
        notificationBody: allowNotificationOrAlert
          ? values.notificationMsg
          : "",
        security: "High", // Default is High
        startDate: isAnnouncement ? values.startDate.utc().format() : "", // Announcement Start Date
        endDate: isAnnouncement ? values.endDate.utc().format() : "", // Announcement End Date
        notificationStartDateTime: allowNotificationOrAlert
          ? notificationDateTime.utc().format()
          : "",
        docName: isAnnouncement ? "Doc Name" : "",
        docContentType: isAnnouncement ? values.documentType : "",
        docUrl: isAnnouncement ? announcementDocUrl : "",
        isImgForNotification:
          allowNotificationOrAlert && values.attachImgOnNotification ? 1 : 0,
        notificationImgAttachType: values.attachImgOnNotification
          ? "upload"
          : "", // Default is upload
        notificationImgUrl:
          allowNotificationOrAlert && values.attachImgOnNotification
            ? notificationImageUrl
            : "",
        isDeepLinkForNotification: values.addDeepLinkOnNotification ? 1 : 0,
        notificationDeepLink: values.addDeepLinkOnNotification
          ? values.deepLink === OTHER_DEEP_LINK
            ? values.otherLink
            : values.deepLink
          : "",
        downloadable: 1, // Default value is 1
        distributionType: values.distributionType,
        audienceType: allowNotificationOrAlert ? "onboarded" : "public",
        isActive: 1, // always 1
        modifiedBy: userData?.user_id ?? "ADMIN",
        notificationScheduleType: values.notifyScheduleType,
        repeatType:
          values.notifyScheduleType === notificationScheduleType.recurring.value
            ? values.notifyRepeatCycle
            : "",
        repeatVal:
          values.notifyScheduleType === notificationScheduleType.recurring.value
            ? values.notifyRepeatCount
            : 0,
        endDateType:
          values.notifyScheduleType === notificationScheduleType.recurring.value
            ? values.notifyEndType
            : "",
        notificationEndDateTime:
          values.notifyScheduleType === notificationScheduleType.recurring.value
            ? values.notifyEndDate.utc().format()
            : "",
        schemeVsModelMappingList:
          values.machineModel.map((item) => {
            return {
              modelNo: item,
            };
          }) ?? [],
        schemeVsGeoMappingList:
          values.distributionType === distributionTypes.geography.value
            ? getGeoMappingList(values.state, values.districts)
            : [],
        schemeVsDlrMappingList:
          values.distributionType === distributionTypes.dealer.value
            ? getDlrMappingList(values.cbu, values.dealers)
            : [],
        schemeVsTenureMappingList: values.distributionType === distributionTypes.tenure.value  ? [{
          fromDate:  values.startJoinDate.utc().format(),
          toDate: values.endJoinDate.utc().format() 
        }] : []  
      };
      setImageUploading(false);
      addUpdateScheme({
        params: requestPayload,
        onSuccess: (response) => {
          setShowSuccessModal(true);
        },
        onError: (error) => {
          const errorMsg =
            get(error, "error.response.data.message") ??
            "Something went wrong, Please try again later.";
          toast.error(errorMsg, {
            position: toast.POSITION.TOP_RIGHT,
          });
        },
      });
    } catch (error) {
      console.log(error,  JSON.stringify(error), "ERROR")
      toast.error("Something went wrong, Please try again later.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  // Handle Test Notification Submit button
  const handleTestNotificationSubmit = async (numbers) => {
    setTestNotificationResponse({});
    try {
      let uploadedBlobUrl = formik.values.notificationImageUrl ?? "";
      if (formik.values.attachImgOnNotification && notificationImage) {
        uploadedBlobUrl = await uploadFileToBlob(notificationImage);
        if (uploadedBlobUrl) {
          formik.setFieldValue("notificationImageUrl", uploadedBlobUrl);

          setNotificationImage(null);
        } else {
          toast.error("Something went wrong, Please try again later.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
      }

      const requestPayload = {
        appId: formik.values.app,
        tenentId: formik.values.tenant,
        mobileNumbers: numbers,
        msg: {
          notification: {
            title: formik.values.notificationTitle,
            body: formik.values.notificationMsg,
            image: formik.values.attachImgOnNotification ? uploadedBlobUrl : "",
          },
          data: {
            route: formik.values.addDeepLinkOnNotification
              ? formik.values.deepLink === OTHER_DEEP_LINK
                ? formik.values.otherLink
                : formik.values.deepLink
              : "",
          },
        },
      };
      sendTestNotification({
        params: requestPayload,
        onSuccess: (response) => {
          console.log("success", response);
          setTestNotificationResponse(response?.data);
          if (response.code === 400) {
            toast.error(response?.message ?? "Notification Not Sent...", {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.success(response?.message ?? "Notification Sent...", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        },
        onError: (error) => {
          const errorMsg =
            get(error, "error.response.data.message") ??
            "Something went wrong, Please try again later.";
          toast.error(errorMsg, {
            position: toast.POSITION.TOP_RIGHT,
          });
        },
      });
    } catch (error) {
      console.log({ error });
    }
  };

  const isSubmitEnable = () => {
    return true;
  };

  const validationSchema = Yup.object().shape({
    documentName: Yup.string().trim().required("Required"),
    description: Yup.string().trim().required("Required"),
    tenant: Yup.string().required("Required"),
    app: Yup.string().required("Required"),
    contentType: Yup.array().test("contentType", "Required", function (val) {
      return val ? val.length > 0 : false;
    }),
    language: Yup.string().required("Required"),
    notificationTitle: Yup.string()
      .trim()
      .when("contentType", {
        is: () => allowNotificationOrAlert,
        then: () =>
          Yup.string()
            .required("Required")
            .max(50, "Notification Title must be at most 50 characters"),
        otherwise: (schema) => schema,
      }),
    notificationMsg: Yup.string()
      .trim()
      .when("contentType", {
        is: () => allowNotificationOrAlert,
        then: () =>
          Yup.string()
            .required("Required")
            .max(150, "Notification Message must be at most 150 characters"),
        otherwise: (schema) => schema,
      }),
    documentType: Yup.string().when("contentType", {
      is: () => isAnnouncement,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    docUrl: Yup.string().when("contentType", {
      is: () => isAnnouncement,
      then: () =>
        Yup.string()
          .when("documentType", {
            is: documentTypes.youtube.value,
            then: () =>
              Yup.string()
                .required("Required")
                .test("docUrl", "Enter Valid URL", function (val) {
                  const youtubeRegex =
                    // eslint-disable-next-line no-useless-escape
                    /^(?:(?:https|http):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be).*?(?:\/|v\/|u\/|embed\/|shorts\/|watch\?v=|(?<username>user\/))(?<id>[\w\-]{11})(?:\?|&|$)/;
                  return val.match(youtubeRegex);
                }),
            otherwise: (schema) => schema,
          })
          .when("documentType", {
            is: documentTypes.html.value,
            then: () =>
              Yup.string()
                .required("Enter HTML Text")
                .test(
                  "docUrl",
                  "Maximum 300 Characters allowed",
                  function (val) {
                    return val.length <= 300;
                  }
                ),
            otherwise: (schema) => schema,
          })
          .when("documentType", {
            is: documentTypes.image.value,
            then: () =>
              Yup.string().required("Required: Image size should be 500x500px"),
            otherwise: (schema) => schema,
          }),
      otherwise: (schema) => schema,
    }),
    notificationImageUrl: Yup.string().when("attachImgOnNotification", {
      is: true,
      then: () =>
        Yup.string().required("Required: Image size should be 600x260px"),
      otherwise: (schema) => schema,
    }),
    deepLink: Yup.string().when("addDeepLinkOnNotification", {
      is: true,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    otherLink: Yup.string().when("deepLink", {
      is: OTHER_DEEP_LINK,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    startDate: Yup.string().when("contentType", {
      is: () => isAnnouncement,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    endDate: Yup.string().when("contentType", {
      is: () => isAnnouncement,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    startJoinDate: Yup.string().when("contentType", {
      is: () => true,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    endJoinDate: Yup.string().when("contentType", {
      is: () => true,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    notifyDate: Yup.string().when("contentType", {
      is: () => allowNotificationOrAlert,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    notifyTime: Yup.string().when("contentType", {
      is: () => allowNotificationOrAlert,
      then: () =>
        Yup.string()
          .required("Required")
          .test(
            "notifyTime",
            "The time should be 30 minutes later than the current time.",
            function (val) {
              const selectedDate = this.parent.notifyDate;
              const dateAndTime = `${moment(selectedDate).format("DD-MM-YYYY")} ${val}`;
              return moment()
                .add("minutes", 30)
                .isBefore(moment(dateAndTime, "DD-MM-YYYY HH:mm"));
            }
          ),
      otherwise: (schema) => schema,
    }),
    notifyScheduleType: Yup.string().when("contentType", {
      is: () => allowNotificationOrAlert,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    notifyRepeatCount: Yup.number().when("notifyScheduleType", {
      is: notificationScheduleType.recurring.value,
      then: () =>
        Yup.number()
          .required("Required")
          .min(1, "Minimum 1")
          .max(10, "Maximum 10"),
      otherwise: (schema) => schema,
    }),
    notifyRepeatCycle: Yup.string().when("notifyScheduleType", {
      is: notificationScheduleType.recurring.value,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    notifyEndType: Yup.string().when("notifyScheduleType", {
      is: notificationScheduleType.recurring.value,
      then: () => Yup.string().required("Required"),
      otherwise: (schema) => schema,
    }),
    notifyEndDate: Yup.string()
      .nullable()
      .when("notifyScheduleType", {
        is: notificationScheduleType.recurring.value,
        then: () =>
          Yup.string().when("notifyEndType", {
            is: notificationEndType.onDate.value,
            then: () => Yup.string().required("Required"),
            otherwise: (schema) => schema,
          }),
        otherwise: (schema) => schema,
      }),
    machineModel: Yup.array().test("machineModel", "Required", function (val) {
      return val ? val.length > 0 : false;
    }),
    state: Yup.array().when("distributionType", {
      is: distributionTypes.geography.value,
      then: () =>
        Yup.array().test("state", "Required", function (val) {
          return val ? val.length > 0 : false;
        }),
      otherwise: (schema) => schema,
    }),
    districts: Yup.array().when("distributionType", {
      is: distributionTypes.geography.value,
      then: () =>
        Yup.array().test("districts", "Required", function (val) {
          return val ? val.length > 0 : false;
        }),
      otherwise: (schema) => schema,
    }),
    cbu: Yup.array().when("distributionType", {
      is: distributionTypes.dealer.value,
      then: () =>
        Yup.array().test("cbu", "Required", function (val) {
          return val ? val.length > 0 : false;
        }),
      otherwise: (schema) => schema,
    }),
    dealers: Yup.array().when("distributionType", {
      is: distributionTypes.dealer.value,
      then: () =>
        Yup.array().test("dealers", "Required", function (val) {
          return val ? val.length > 0 : false;
        }),
      otherwise: (schema) => schema,
    }),
  });

  // Get State District Mapping
  const getGeoMappingList = (selectedStates, selectedDistricts) => {
    if (selectedDistricts?.includes("all")) {
      if (selectedStates.includes("all")) {
        return [{ stateId: 0, districtId: 0 }];
      }
      return selectedStates.map((item) => {
        return { stateId: item, districtId: 0 };
      });
    }
    return selectedDistricts.map((item) => {
      const stateId =
        districtsList?.find((dist) => dist.value === item)?.state_id ?? null;
      return { stateId: stateId, districtId: item };
    });
  };

  // Get CBU and Dealer Mapping
  const getDlrMappingList = (selectedCBU, selectedDealer) => {
    if (selectedDealer?.includes("all")) {
      if (selectedCBU.includes("all")) {
        return [
          {
            cbuCode: "all",
            dealerCode: "all",
          },
        ];
      }
      return selectedCBU.map((item) => {
        return { cbuCode: item, dealerCode: "all" };
      });
    }
    return selectedDealer.map((item) => {
      const cbuCode =
        dealersList?.find((dealer) => dealer.value === item)?.erpcbucode ??
        null;
      return { cbuCode: cbuCode, dealerCode: item };
    });
  };

  useEffect(() => {
    if (isEditMode && !isEmpty(schemeById)) {
      if (!isEmpty(schemeById?.startDate)) {
        setStartDate(moment(schemeById?.startDate));
      }
      if (!isEmpty(schemeById?.endDate)) {
        setEndDate(moment(schemeById?.endDate));
      }

      if (schemeById?.notificationStartDateTime) {
        setNotifyDate(moment(schemeById?.notificationStartDateTime));
        setNotifyTime(
          moment(schemeById?.notificationStartDateTime).format("HH:mm")
        );
      }
      if (
        schemeById?.notificationEndDateTime &&
        schemeById?.endDateType === notificationEndType.onDate.value
      ) {
        setNotifyEndDate(moment(schemeById?.notificationEndDateTime));
      }
      let fromDate = schemeById?.schemeVsTenureMappingList?.[0]?.fromDate
      let toDate = schemeById?.schemeVsTenureMappingList?.[0]?.toDate
      if(!!fromDate) {
        setStartJoinDate(moment(fromDate));
      }
      if(!!toDate){
        setEndJoinDate(moment(toDate));
      }
    }
  }, [schemeById, isEditMode]);

  const addedContentType = useMemo(() => {
    const contentMappingList = schemeById?.schemeVsDocTypeMappingList ?? [];
    return contentMappingList.map((item) => item?.docType?.toLowerCase());
  }, [schemeById]);

  // Currently Not in use
  // eslint-disable-next-line no-unused-vars
  const addedMachineModels = useMemo(() => {
    const modelList = schemeById?.schemeVsModelMappingList ?? [];
    return modelList.map((item) => item.modelNo);
  }, [schemeById]);

  const addedGeoMapping = useMemo(() => {
    const geoData = schemeById?.schemeVsGeoMappingList ?? [];
    let states = [];
    const districts = geoData.map((item) => {
      if (!states.includes(item.stateId) && item.stateId !== 0) {
        states.push(item.stateId);
      } else if (item.stateId === 0) {
        states.push("all");
      }
      return item.districtId === 0 ? "all" : item.districtId;
    });
    return { states: states, districts: districts };
  }, [schemeById]);

  const addedDealerMapping = useMemo(() => {
    const dealerData = schemeById?.schemeVsDlrMappingList ?? [];
    let cbu = [];
    const dealers = dealerData.map((item) => {
      if (!cbu.includes(item.cbuCode)) {
        cbu.push(item.cbuCode);
      }
      return item.dealerCode;
    });
    return { cbu: cbu, dealers: dealers };
  }, [schemeById]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      documentName: isEditMode ? (schemeById?.documentName ?? "") : "",
      description: isEditMode ? (schemeById?.documentDesc ?? "") : "",
      tenant: isEditMode ? (schemeById?.tenant ?? "") : "",
      app: isEditMode ? appInfo(schemeById?.appId).appId : "",
      contentType: isEditMode ? addedContentType : [],
      language:
        isEditMode && schemeById?.language
          ? schemeById?.language
          : languageOptions[0].value,
      notificationTitle: isEditMode
        ? (schemeById?.notificationTitle ?? "")
        : "",
      notificationMsg: isEditMode ? (schemeById?.notificationBody ?? "") : "",
      documentType: isEditMode
        ? (schemeById?.docContentType?.toLowerCase() ?? "")
        : "",
      docUrl: isEditMode ? (schemeById?.docUrl ?? "") : "",
      attachImgOnNotification: isEditMode
        ? !!schemeById?.isImgForNotification
        : false,
      addDeepLinkOnNotification: isEditMode
        ? !!schemeById?.isDeepLinkForNotification
        : false,
      notificationImageUrl: isEditMode
        ? (schemeById?.notificationImgUrl ?? "")
        : "",
      deepLink: "",
      otherLink: "",
      startDate: startDate,
      endDate: endDate,
      startJoinDate: startJoinDate,
      endJoinDate: endJoinDate,
      notifyDate: notifyDate,
      notifyTime: notifyTime,
      machineModel: ["all"], // Always All
      notifyScheduleType:
        isEditMode && schemeById?.notificationScheduleType
          ? schemeById?.notificationScheduleType
          : notificationScheduleType.onDate.value,
      notifyRepeatCount:
        isEditMode && schemeById?.repeatVal ? schemeById?.repeatVal : 1,
      notifyRepeatCycle:
        isEditMode && schemeById?.repeatType
          ? schemeById?.repeatType
          : repeatCycle.hour.value,
      notifyEndType:
        isEditMode && schemeById?.endDateType
          ? schemeById?.endDateType
          : notificationEndType.onDate.value,
      notifyEndDate: notifyEndDate,
      distributionType:
        isEditMode && schemeById?.distributionType
          ? schemeById?.distributionType
          : distributionTypes.geography.value,
      state: isEditMode ? addedGeoMapping.states : [],
      districts: isEditMode ? addedGeoMapping.districts : [],
      cbu: isEditMode ? addedDealerMapping.cbu : [],
      dealers: isEditMode ? addedDealerMapping.dealers : [],
      // audience: "",
    },
    validationSchema: validationSchema,
    validateOnBlur: false,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (!isEmpty(schemeById)) {
      const appId = appInfo(schemeById?.appId).appId;
      if (appId)
        getAllDeepLinks({
          appId: appId,
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schemeById]);

  useEffect(() => {
    if (!isEmpty(schemeById) && !isEmpty(allDeepLinks)) {
      const notificationDeepLink = schemeById?.notificationDeepLink ?? "";
      const appId = appInfo(schemeById?.appId).appId ?? "";
      let isOtherLink = true;

      if (allDeepLinks && allDeepLinks[appId]) {
        const allDeepLinksData = [...Object.values(allDeepLinks[appId])];
        allDeepLinksData.forEach((item) => {
          if (item.value === notificationDeepLink) {
            isOtherLink = false;
          }
        });
        if (!isEmpty(notificationDeepLink)) {
          formik.setFieldValue(
            "deepLink",
            isOtherLink ? OTHER_DEEP_LINK : notificationDeepLink
          );
          formik.setFieldValue(
            "otherLink",
            isOtherLink ? notificationDeepLink : ""
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schemeById, allDeepLinks]);

  const districtOptions = useMemo(() => {
    const selectedState = formik.values.state;
    if (selectedState?.length && districtsList?.length) {
      if (selectedState.includes("all")) {
        return districtsList;
      }
      const distList = districtsList?.filter?.((val) => {
        const state = selectedState?.findIndex((s) => s === val.state_id);
        return val?.District_Id && state > -1;
      });
      return distList;
    }
    return [];
  }, [formik.values.state, districtsList]);

  const dealersList = useMemo(() => {
    const selectedDealerERP = formik.values.cbu;
    try {
      const dealers = allDealersList?.reduce?.((arr, dealer) => {
        const i = selectedDealerERP?.findIndex(
          (val) => val === dealer?.erpcbucode
        );
        const isAllSelected = selectedDealerERP.includes("all");
        if (i >= 0 || isAllSelected) {
          arr.push({
            ...dealer,
            value: dealer?.dealerCode,
            label: dealer?.dealerName,
          });
        }
        return arr;
      }, []);
      return dealers;
    } catch {
      return [];
    }
  }, [formik.values.cbu, allDealersList]);

  const allowNotificationOrAlert = useMemo(() => {
    const contentTypeData = formik.values.contentType ?? [];
    let returnValue = false;
    contentTypeData.forEach((item) => {
      if (
        item === CONTENT_TYPES.inAppAlert.value ||
        item === CONTENT_TYPES.pushNotification.value ||
        item === "all"
      ) {
        returnValue = true;
      }
    });
    return returnValue;
  }, [formik.values.contentType]);

  const isAnnouncement = useMemo(() => {
    const contentTypeData = formik.values.contentType ?? [];
    let returnValue = false;
    contentTypeData.forEach((item) => {
      if (item === CONTENT_TYPES.announcement.value || item === "all") {
        returnValue = true;
      }
    });
    return returnValue;
  }, [formik.values.contentType]);

  const deepLinkOptions = useMemo(() => {
    if (allDeepLinks) {
      const deepLinkData = allDeepLinks[formik.values.app] ?? {};

      const withOther = {
        ...deepLinkData,
        other: { value: "other", label: "Other" },
      };

      return Object.values(withOther) ?? [];
    }
    return [];
  }, [formik.values.app, allDeepLinks]);

  return (
    <MainContainer>
      <BackContainer onClick={() => history.goBack()}>
        <Icon icon="backIcon" color={"#000"} />
      </BackContainer>
      <Typography variant="h5" fontWeight={700} color={"#003E85"}>
        {isEditMode
          ? "Update Announcement/Notification"
          : "Create Announcement/Notification"}
      </Typography>
      <FormikProvider value={formik}>
        <Form>
          <ContainerBox label={"Information"}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormTextField
                  name="documentName"
                  label="Document Name"
                  required
                  placeholder={"Enter Document Name"}
                />
              </Grid>
              <Grid item xs={6}>
                <FormTextField
                  name="description"
                  label="Description"
                  required
                  multiline
                  placeholder={"Enter Description"}
                />
              </Grid>
              <Grid item xs={3}>
                <FormSelectInput
                  name="tenant"
                  options={tenantList}
                  label="Tenant*"
                  onChange={(e) => {
                    formik.setFieldValue("deepLink", "");
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <FormSelectInput
                  name="app"
                  options={appList(formik.values.tenant)}
                  label="App*"
                  onChange={(e) => {
                    formik.setFieldValue("deepLink", "");
                    getAllDeepLinks({
                      appId: e?.target?.value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <FormSelectInput
                  name="contentType"
                  options={Object.values(CONTENT_TYPES)}
                  label="Content Type*"
                  multiple
                />
              </Grid>
              <Grid item xs={3}>
                <FormSelectInput
                  name="language"
                  options={languageOptions}
                  label="Language*"
                />
              </Grid>
            </Grid>
            {allowNotificationOrAlert && (
              <>
                <Typography
                  variant="body1"
                  fontWeight={700}
                  marginTop={1}
                  marginBottom={1}
                >
                  {"Notification/Alerts"}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <FormTextField
                      name="notificationTitle"
                      multiline
                      label="Title"
                      required
                      placeholder={"Enter Notification Title"}
                      helperText={"Maximum 50 characters"}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormTextField
                      name="notificationMsg"
                      multiline
                      label="Message"
                      required
                      placeholder={"Enter Notification Message"}
                      helperText={"Maximum 150 characters"}
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </ContainerBox>
          {(isAnnouncement || allowNotificationOrAlert) && (
            <>
              <ContainerBox label={"Content"}>
                {isAnnouncement && (
                  <>
                    <Typography
                      variant="body1"
                      fontWeight={700}
                      marginTop={-1}
                      marginBottom={1}
                    >
                      {"Announcement"}
                    </Typography>
                    <Grid
                      container
                      spacing={2}
                      justifyContent={"space-between"}
                    >
                      <Grid item xs={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <FormSelectInput
                              name="documentType"
                              options={Object.values(documentTypes)}
                              label="Document Type*"
                              onChange={(e) => {
                                formik.setFieldValue("docUrl", "");
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            {formik.values.documentType ===
                              documentTypes.youtube.value && (
                              <FormTextField
                                name="docUrl"
                                label="Youtube URL"
                                multiline
                                required
                                placeholder={"Enter Youtube URL"}
                                helperText={"Text should be youtube link"}
                              />
                            )}
                            {formik.values.documentType ===
                              documentTypes.image.value && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    width: 500,
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    id="selectImage"
                                    type="file"
                                    onChange={(e) => {
                                      const file = e.target?.files[0];
                                      if (!file) return;
                                      if (!IMAGE_MIME.includes(file?.type)) {
                                        alert(
                                          "Invalid File. Please select an image."
                                        );
                                        return;
                                      }
                                      if (file) {
                                        formik.setFieldTouched("docUrl", true);

                                        const img = new Image();
                                        img.src =
                                          window.URL.createObjectURL(file);
                                        img.onload = () => {
                                          const width = img.naturalWidth;
                                          const height = img.naturalHeight;

                                          if (width === 500 && height === 500) {
                                            setAnnouncementImage(file);
                                            formik.setFieldValue(
                                              "docUrl",
                                              img.src
                                            );
                                          } else {
                                            window.URL.revokeObjectURL(img.src);
                                            setAnnouncementImage(null);
                                            formik.setFieldValue("docUrl", "");
                                            alert(
                                              "Image size should be 500x500px"
                                            );
                                            e.target.value = null;
                                          }
                                        };
                                      }
                                    }}
                                    accept={IMAGE_MIME.join(",")}
                                  />
                                  <Typography variant="Body2" fontWeight={400}>
                                    {announcementImage
                                      ? announcementImage.name
                                      : formik.values.docUrl
                                        ? formik.values?.docUrl?.match(
                                            /.*\/(.*)$/
                                          )[1]
                                        : "No File Chosen"}
                                  </Typography>
                                </div>
                                <Typography
                                  variant="caption"
                                  fontWeight={400}
                                  color={
                                    formik.touched.docUrl &&
                                    formik.errors.docUrl
                                      ? "error"
                                      : "rgba(0, 0, 0, 0.6)"
                                  }
                                  style={{ marginLeft: 8, marginTop: 4 }}
                                >
                                  {formik.touched.docUrl && formik.errors.docUrl
                                    ? formik.errors.docUrl
                                    : "Image size should be 500x500px"}
                                </Typography>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      {formik.values.docUrl &&
                        formik.values.documentType !==
                          documentTypes.html.value && (
                          <Grid item xs={3}>
                            <DocumentPreview
                              contentData={formik.values.docUrl}
                              contentType={formik.values.documentType}
                            />
                          </Grid>
                        )}
                      {formik.values.documentType ===
                        documentTypes.html.value && (
                        <Grid item xs={12}>
                          <div data-color-mode="light">
                            <MarkdownEditor
                              height={"400px"}
                              value={formik.values.docUrl}
                              toolbars={[
                                "undo",
                                "redo",
                                "bold",
                                "italic",
                                "header",
                                "strike",
                                "underline",
                                "quote",
                                "olist",
                                "ulist",
                                "todo",
                                "link",
                              ]}
                              onChange={(val) => {
                                formik.setFieldValue("docUrl", val);
                              }}
                            />
                            <Typography
                              variant="caption"
                              fontWeight={400}
                              color={
                                formik.errors.docUrl
                                  ? "error"
                                  : "rgba(0, 0, 0, 0.6)"
                              }
                              style={{ marginLeft: 8, marginTop: 4 }}
                            >
                              {formik.errors.docUrl ?? "Enter HTML Text"}
                            </Typography>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  </>
                )}
                {allowNotificationOrAlert && (
                  <>
                    <Typography variant="body1" fontWeight={700}>
                      {"Notification/Alerts"}
                    </Typography>
                    <Grid
                      container
                      spacing={2}
                      justifyContent={"space-between"}
                    >
                      <Grid item xs={6}>
                        <Grid container spacing={1} xs={6}>
                          <Grid item xs={12}>
                            <div
                              style={{
                                justifyContent: "space-between",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <FormLabel>{"Attach Image"}</FormLabel>
                              <Switch
                                name="attachImgOnNotification"
                                checked={formik.values.attachImgOnNotification}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "attachImgOnNotification",
                                    e.target.checked
                                  );
                                }}
                              />
                            </div>
                            {formik.values.attachImgOnNotification && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    width: 500,
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    id="selectNotifyImage"
                                    type="file"
                                    onChange={(e) => {
                                      const file = e.target?.files[0];
                                      if (!file) return;
                                      if (!IMAGE_MIME.includes(file?.type)) {
                                        alert(
                                          "Invalid File. Please select an image."
                                        );
                                        e.target.value = null;
                                        return;
                                      }
                                      if (file) {
                                        formik.setFieldTouched(
                                          "notificationImageUrl",
                                          true
                                        );

                                        const img = new Image();
                                        img.src =
                                          window.URL.createObjectURL(file);
                                        img.onload = () => {
                                          const width = img.naturalWidth;
                                          const height = img.naturalHeight;

                                          if (width === 600 && height === 260) {
                                            setNotificationImage(file);
                                            formik.setFieldValue(
                                              "notificationImageUrl",
                                              img.src
                                            );
                                          } else {
                                            window.URL.revokeObjectURL(img.src);
                                            setNotificationImage(null);
                                            formik.setFieldValue(
                                              "notificationImageUrl",
                                              ""
                                            );
                                            alert(
                                              "Image size should be 600x260px"
                                            );
                                            e.target.value = null;
                                          }
                                        };
                                      }
                                    }}
                                    accept={IMAGE_MIME.join(",")}
                                  />
                                  <Typography variant="Body2" fontWeight={400}>
                                    {notificationImage
                                      ? notificationImage.name
                                      : formik.values.notificationImageUrl
                                        ? formik.values?.notificationImageUrl?.match(
                                            /.*\/(.*)$/
                                          )[1]
                                        : "No File Chosen"}
                                  </Typography>
                                </div>
                                <Typography
                                  variant="caption"
                                  fontWeight={400}
                                  color={
                                    formik.touched.notificationImageUrl &&
                                    formik.errors.notificationImageUrl
                                      ? "error"
                                      : "rgba(0, 0, 0, 0.6)"
                                  }
                                  style={{ marginLeft: 8, marginTop: 4 }}
                                >
                                  {formik.touched.notificationImageUrl &&
                                  formik.errors.notificationImageUrl
                                    ? formik.errors.notificationImageUrl
                                    : "Image size should be 600x260px"}
                                </Typography>
                              </div>
                            )}
                          </Grid>
                          <Grid item xs={12}>
                            <div
                              style={{
                                justifyContent: "space-between",
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <FormLabel>{"Deep Link"}</FormLabel>
                              <Switch
                                name="addDeepLinkOnNotification"
                                checked={
                                  formik.values.addDeepLinkOnNotification
                                }
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "addDeepLinkOnNotification",
                                    e.target.checked
                                  );
                                }}
                              />
                            </div>
                            {formik.values.addDeepLinkOnNotification && (
                              <FormSelectInput
                                name="deepLink"
                                options={deepLinkOptions}
                                label="Navigate To*"
                                sorted={false}
                                helperText="Select page to navigate"
                              />
                            )}
                          </Grid>
                        </Grid>
                        {formik.values.addDeepLinkOnNotification &&
                          formik.values.deepLink === OTHER_DEEP_LINK && (
                            <Grid item xs={12} marginTop={2}>
                              <FormTextField
                                name="otherLink"
                                multiline
                                label="Link"
                                required
                                placeholder={"Enter Navigate Link"}
                                helperText={"Text should be link"}
                              />
                            </Grid>
                          )}
                      </Grid>
                      {formik.values.attachImgOnNotification &&
                        formik.values.notificationImageUrl && (
                          <Grid item xs={3}>
                            <DocumentPreview
                              contentData={formik.values.notificationImageUrl}
                              contentType={documentTypes.image}
                            />
                          </Grid>
                        )}
                      <Grid item xs={12}>
                        <Button
                          label={"Send Test Notification"}
                          labelColor={"white"}
                          type={"button"}
                          style={{
                            height: 30,
                            borderRadius: 4,
                            paddingLeft: 20,
                            paddingRight: 20,
                          }}
                          disabled={
                            isEmpty(formik.values.tenant) ||
                            isEmpty(formik.values.app) ||
                            isEmpty(formik.values.notificationTitle) ||
                            isEmpty(formik.values.notificationMsg)
                          }
                          onClick={() => {
                            setShowTestNotifyModal(true);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </ContainerBox>
              <ContainerBox label={"Schedule"}>
                {isAnnouncement && (
                  <>
                    <Typography
                      variant="body1"
                      fontWeight={700}
                      marginTop={-1}
                      marginBottom={1}
                    >
                      {"Announcement"}
                    </Typography>
                    <Grid container spacing={2} marginBottom={2}>
                      <Grid item xs={3}>
                        <DatePicker
                          id="starDate"
                          label="Start Date*"
                          type="single"
                          openDirection="OPEN_UP"
                          date={formik.values.startDate}
                          onDateChange={(date) => {
                            formik.setFieldValue("startDate", date);
                            if (date.isAfter(formik.values.endDate)) {
                              formik.setFieldValue("endDate", null);
                            }
                          }}
                          isOutsideRange={(day) =>
                            day.isBefore(
                              moment().endOf("day").subtract(1, "days")
                            )
                          }
                          showDateLabel={true}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <DatePicker
                          id="endDate"
                          label="End Date*"
                          type="single"
                          openDirection="OPEN_UP"
                          date={formik.values.endDate}
                          onDateChange={(date) =>
                            formik.setFieldValue("endDate", date)
                          }
                          isOutsideRange={(day) =>
                            day.isBefore(
                              formik.values?.startDate?.subtract(0, "days")
                            )
                          }
                          showDateLabel={true}
                        />
                        {formik.errors.endDate && (
                          <Typography
                            variant="caption"
                            fontWeight={400}
                            color={"error"}
                            style={{ marginLeft: 8, marginTop: 4 }}
                          >
                            {formik.errors.endDate}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </>
                )}
                {allowNotificationOrAlert && (
                  <>
                    <Typography variant="body1" fontWeight={700}>
                      {"Notification/Alerts"}
                    </Typography>
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        value={formik.values.notifyScheduleType}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "notifyScheduleType",
                            e.target.value
                          )
                        }
                      >
                        <FormControlLabel
                          value={notificationScheduleType.onDate.value}
                          control={<Radio />}
                          label={notificationScheduleType.onDate.label}
                          style={{ marginRight: 50 }}
                        />
                        <FormControlLabel
                          value={notificationScheduleType.recurring.value}
                          control={<Radio />}
                          label={notificationScheduleType.recurring.label}
                        />
                      </RadioGroup>
                    </FormControl>
                    <Grid container spacing={2} xs={6}>
                      <Grid item xs={6}>
                        <DatePicker
                          id="notifyDate"
                          label={"Start Date*"}
                          type="single"
                          openDirection="OPEN_UP"
                          date={formik.values.notifyDate}
                          onDateChange={(date) => {
                            formik.setFieldValue("notifyDate", date);
                            if (date.isAfter(formik.values.notifyDate)) {
                              formik.setFieldValue("notifyEndDate", null);
                            }
                          }}
                          isOutsideRange={(day) =>
                            day.isBefore(
                              moment().endOf("day").subtract(1, "days")
                            )
                          }
                          showDateLabel={true}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormTextField
                          name="notifyTime"
                          label="Time*"
                          type="time"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      {formik.values.notifyScheduleType ===
                        notificationScheduleType.recurring.value && (
                        <>
                          <Grid item xs={3}>
                            <FormTextField
                              name="notifyRepeatCount"
                              label="Repeat Every*"
                              type="number"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{ max: 10, min: 1 }}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <FormSelectInput
                              name="notifyRepeatCycle"
                              options={Object.values(repeatCycle)}
                            />
                          </Grid>
                          {/* <Grid item xs={6} /> */}
                          {/* <Grid item xs={6}>
                            <FormSelectInput
                              name="notifyEndType"
                              label="End"
                              options={Object.values(notificationEndType)}
                            />
                          </Grid> */}
                          {formik.values.notifyEndType ===
                            notificationEndType.onDate.value && (
                            <Grid item xs={6}>
                              <DatePicker
                                id="notifyEndDate"
                                label="End Date*"
                                type="single"
                                openDirection="OPEN_UP"
                                date={formik.values.notifyEndDate}
                                onDateChange={(date) =>
                                  formik.setFieldValue("notifyEndDate", date)
                                }
                                isOutsideRange={(day) =>
                                  day.isBefore(
                                    formik.values?.notifyDate?.subtract(
                                      0,
                                      "days"
                                    )
                                  )
                                }
                                showDateLabel={true}
                              />
                              {formik.errors.notifyEndDate && (
                                <Typography
                                  variant="caption"
                                  fontWeight={400}
                                  color={"error"}
                                  style={{ marginLeft: 8, marginTop: 4 }}
                                >
                                  {formik.errors.notifyEndDate}
                                </Typography>
                              )}
                            </Grid>
                          )}
                        </>
                      )}
                    </Grid>
                  </>
                )}
              </ContainerBox>
            </>
          )}
          <ContainerBox label={"Distribution"}>
            <Grid container spacing={2} xs={6}>
              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    value={formik.values.distributionType}
                    onChange={(e) =>
                      formik.setFieldValue("distributionType", e.target.value)
                    }
                  >
                    <FormControlLabel
                      value={distributionTypes.geography.value}
                      control={<Radio />}
                      label={distributionTypes.geography.label}
                    />
                    <FormControlLabel
                      value={distributionTypes.dealer.value}
                      control={<Radio />}
                      label={distributionTypes.dealer.label}
                    />
                     <FormControlLabel
                      value={distributionTypes.tenure.value}
                      control={<Radio />}
                      label={distributionTypes.tenure.label}  
                    />
                  </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                  {formik.values.distributionType ===
                    distributionTypes.geography.value && (
                    <>
                      <Grid item xs={6}>
                        <FormSelectInput
                          name="state"
                          options={states}
                          label="State*"
                          onChange={(e) => {
                            if (e.target?.value?.includes("all")) {
                              formik.setFieldValue("districts", ["all"]);
                            } else {
                              formik.setFieldValue("districts", []);
                            }
                            setTimeout(() => formik.validateField("districts"));
                          }}
                          multiple
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormSelectInput
                          name="districts"
                          options={districtOptions}
                          label="District*"
                          disabled={formik.values.state.includes("all")}
                          multiple
                        />
                      </Grid>
                    </>
                  )}
                  {formik.values.distributionType ===
                    distributionTypes.dealer.value && (
                    <>
                      <Grid item xs={6}>
                        <FormSelectInput
                          name="cbu"
                          options={dealersERPList}
                          label="CBU*"
                          onChange={(e) => {
                            if (e.target?.value?.includes("all")) {
                              formik.setFieldValue("dealers", ["all"]);
                            } else {
                              formik.setFieldValue("dealers", []);
                            }
                            setTimeout(() => formik.validateField("dealers"));
                          }}
                          multiple
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormSelectInput
                          name="dealers"
                          options={
                            !isEmpty(formik.values.cbu) ? dealersList : []
                          }
                          label="Dealers*"
                          multiple
                        />
                      </Grid>
                    </>
                  )}
                   {formik.values.distributionType ===
                    distributionTypes.tenure.value && (
                    <>
                      <Grid item xs={6}>
                        <DatePicker
                          id="starDate"
                          label="Start Date*"
                          type="single"
                          openDirection="OPEN_UP"
                          date={formik.values.startJoinDate}
                          onDateChange={(date) => {
                            formik.setFieldValue("startJoinDate", date);
                            if (date.isAfter(formik.values.endJoinDate)) {
                              formik.setFieldValue("endJoinDate", null);
                            }
                          }}
                          isOutsideRange={(day) => null}
                            // day.isBefore(
                            //   moment().endOf("day").subtract(10, "years")
                            // )}
                          showDateLabel={true}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <DatePicker
                          id="endDate"
                          label="End Date*"
                          type="single"
                          openDirection="OPEN_UP"
                          date={formik.values.endJoinDate}
                          onDateChange={(date) => {
                            formik.setFieldValue("endJoinDate", date);
                            if (date.isBefore(formik.values.startJoinDate)) {
                              formik.setFieldValue("startJoinDate", null);
                            }
                          }}
                          isOutsideRange={(day) => 
                            day.isAfter(
                              moment().endOf("day").add(1, "days")
                            )}
                          showDateLabel={true}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
            {/* {allowNotificationOrAlert && (
              <>
                <Typography
                  variant="body1"
                  fontWeight={700}
                  marginTop={2}
                  marginBottom={1}
                >
                  {"Notification/Alerts"}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <FormSelectInput
                      name="audience"
                      options={notificationAudience}
                      label="Audience"
                    />
                  </Grid>
                </Grid>
              </>
            )} */}
          </ContainerBox>
        </Form>
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            marginTop: 30,
          }}
        >
          <button
            style={{
              backgroundColor: isSubmitEnable() ? "#003E85" : "#F5F5F5",
              border: "none",
              padding: "11px",
              paddingLeft: "17px",
              paddingRight: "17px",
              fontFamily: "Roboto-Bold",
              color: isSubmitEnable() ? "#fff" : "#d1d1d1",
              fontSize: "16px",
              cursor: "pointer",
              borderRadius: "4px",
              width: "150px",
            }}
            onClick={formik.handleSubmit}
          >
            {"SUBMIT"}
          </button>
        </div>
      </FormikProvider>

      {showTestNotifyModal && (
        <TestNotification
          apiResponse={testNotificationResponse}
          isLoading={visible}
          onSubmit={handleTestNotificationSubmit}
          onCancel={() => {
            setShowTestNotifyModal(false);
            setTestNotificationResponse({});
          }}
        />
      )}

      {showSuccessModal && (
        <Modal
          onSubmit={() => {
            setShowSuccessModal(false);
            clearAddScheme();
            history.goBack();
          }}
          confirmTitle={"OK"}
        >
          {/* <div style={{ display: "flex", alignSelf: "flex-end" }}>
            <Icon icon="circleClose" />
          </div> */}
          <div
            style={{
              display: "flex",
              alignSelf: "center",
              marginTop: "31px",
            }}
          >
            <Icon icon="checkIcon" />
          </div>
          <StyledText
            textAlign={"center"}
            width={"100%"}
            viewPadding={"20px 0px"}
          >
            {isEditMode
              ? "Document has been updated successfully"
              : "Document has been added successfully"}
          </StyledText>
        </Modal>
      )}
      {(visible || imageUploading) && (
        <LoaderContainer>
          <Circle size="Large" />
        </LoaderContainer>
      )}
    </MainContainer>
  );
};

const mapStateToProps = ({
  app: { visible },
  schemes: { newSchemeById: schemeById, allDeepLinks },
  dealers: { allStates, allDealers, allDistricts },
  user: { userData, allModels },
}) => ({
  userData,
  allStates,
  allDealers,
  visible,
  allModels,
  allDistricts,
  schemeById,
  allDeepLinks,
});

export default connect(mapStateToProps, {
  getAllDealers: getAllDealers,
  getAllStates: getAllStates,
  clearAddScheme: clearAddScheme,
  getAllModel: getAllModel,
  getAllDistricts: getAllDistricts,
  getSchemesById: getNewSchemesById,
  addUpdateScheme: addUpdateNewScheme,
  sendTestNotification: sendTestNotification,
  getAllDeepLinks: getAllDeepLinks,
})(UploadPromotion);
